import { render } from "./ProductSelect.vue?vue&type=template&id=085e86e0&ts=true"
import script from "./ProductSelect.vue?vue&type=script&lang=ts"
export * from "./ProductSelect.vue?vue&type=script&lang=ts"

import "./ProductSelect.vue?vue&type=style&index=0&id=085e86e0&lang=css"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__